
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { VueTelInput } from 'vue-tel-input';

interface PhoneNumberCountry {
  areaCodes: string;
  dialCode: string;
  iso2: string;
  name: string;
  priority: number;
}

interface PhoneNumber {
  country?: PhoneNumberCountry;
  countryCallingCode?: string;
  countryCode?: string;
  formatted?: string;
  nationalNumber?: string;
  number?: string;
  valid?: boolean;
}

@Component({ components: { VueTelInput } })
export default class PhoneSelect extends Vue {
  valid = false;

  @Prop({ default: '' })
  value!: string;

  @Prop({ default: false })
  required!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Emit()
  input(phoneString: string, phoneObject: PhoneNumber): string | undefined {
    return phoneObject.number;
  }

  @Emit()
  validate(phoneObject: PhoneNumber): boolean {
    if (phoneObject.valid !== undefined && phoneObject.valid) {
      this.valid = true;
    } else {
      this.valid = phoneObject.formatted === '';
    }
    return this.valid;
  }
}
